import React, { useRef } from "react";
import { Box } from "@mui/material";
import { makeStyles } from "tss-react/mui";
import "../icons/Icon.js";
import { CustomIcon } from "../icons/types.js";
import "../icons/ExpandMoreIcon.js";
import "../input/validation.js";
import "../input/DatePicker.js";
import "../input/DateRangePicker.js";
import "../input/StyledInput.js";
import { FormTextInputCleanable } from "../input/FormInput.js";
import "../input/StyledFormInputHoc.js";
import "moment-timezone";
import "react-intl";
import "../input/DateSinglePicker.localize.js";
import "../input/hooks.js";
const useClasses = makeStyles()((theme) => ({
  filterText: {
    "& .MuiInputBase-input": {
      height: theme.custom.denseButtonHeight - 2,
      textOverflow: "ellipsis"
    }
  },
  filterTextStartInputAdornment: {
    color: theme.palette.secondary.main,
    fontSize: 12
  },
  filterTextCleanableLimitMaxWidth: {
    maxWidth: theme.custom.filterTextInputMaxWidth,
    width: theme.custom.filterTextInputMaxWidth
  }
}));
const TextFilter = ({ value, onChange, onEnter, width, inputPlaceholder, mode, disallowSpecialCharacters }) => {
  const { classes, cx } = useClasses();
  const debounceTimer = useRef(null);
  function handleChange(e) {
    if (debounceTimer.current) {
      clearTimeout(debounceTimer.current);
    }
    const delay = mode === "update-on-submit" ? 0 : 500;
    debounceTimer.current = setTimeout(() => {
      onChange(e.target.value);
    }, delay);
  }
  function handleKeyDown(e) {
    if (e.key === "Enter") {
      onEnter?.(e.target.value);
    }
  }
  function handleClear() {
    onChange("");
  }
  return /* @__PURE__ */ React.createElement(
    FormTextInputCleanable,
    {
      value,
      className: cx({ [classes.filterTextCleanableLimitMaxWidth]: width === "fixed" }, classes.filterText),
      startAdornment: /* @__PURE__ */ React.createElement(Box, { component: "span", className: `${CustomIcon.Search} ${classes.filterTextStartInputAdornment}` }),
      style: { marginBottom: 0 },
      onChange: handleChange,
      onKeyDown: handleKeyDown,
      clear: handleClear,
      placeholder: inputPlaceholder,
      disallowSpecialCharacters
    }
  );
};
const TextFilterFixedWidth = (props) => /* @__PURE__ */ React.createElement(TextFilter, { ...props, width: "fixed" });
const TextFilterFullWidth = (props) => /* @__PURE__ */ React.createElement(TextFilter, { ...props, width: "full" });
export {
  TextFilter,
  TextFilterFixedWidth,
  TextFilterFullWidth,
  useClasses
};
//# sourceMappingURL=TextFilter.js.map
